import { Link as RouterLink } from 'react-router-dom';
import { Typography } from '@src/components/Typography/Typography';
import { testIdAttr } from '@src/components/testId';
import { isInAppHref } from '@src/routing/href';
import './Brand.css';

export type BrandTone = 'default' | 'inverse';
export type BrandSize = 'default' | 'display';

export interface BrandProps {
  href?: string;
  children?: string;
  /** White wordmark for the dark footer. */
  tone?: BrandTone;
  /** Display is the landing wordmark — viewport-scaled. */
  size?: BrandSize;
  testId?: string;
}

export function Brand({
  href = '/',
  children = 'secret santa',
  tone = 'default',
  size = 'default',
  testId,
}: BrandProps) {
  const classes = ['brand'];
  if (tone === 'inverse') {
    classes.push('brand--inverse');
  }
  if (size === 'display') {
    classes.push('brand--display');
  }

  const inApp = isInAppHref(href);

  return (
    <Typography
      as={inApp ? RouterLink : 'a'}
      role={size === 'display' ? 'title/landing' : 'title/section'}
      color={tone === 'inverse' ? 'inherit' : 'role'}
      className={classes.join(' ')}
      {...(inApp ? { to: href } : { href })}
      {...testIdAttr(testId)}
    >
      {children}
      <span className="brand__dot">.</span>
    </Typography>
  );
}
